import { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { LogoMark } from "../Logo";

const API = "/api";

export default function AdminLogin({ onSignedIn }) {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({ defaultValues: { email: "" } });
    const [error, setError] = useState("");

    const onSubmit = async (data) => {
        setError("");
        try {
            const { data: res } = await axios.post(`${API}/admin/login`, data, { withCredentials: true });
            onSignedIn(res.user);
        } catch (e) {
            const detail = e.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Sign-in failed. Please try again.");
        }
    };

    return (
        <div className="grid min-h-screen place-items-center bg-cream px-5">
            <form onSubmit={handleSubmit(onSubmit)} noValidate data-testid="admin-login-form" className="w-full max-w-md rounded-3xl border border-clay bg-white p-9">
                <div className="text-center">
                    <LogoMark className="mx-auto h-14 w-14" />
                    <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-ink">Admin sign in</h1>
                    <p className="mt-2 text-lg leading-relaxed text-ink-soft">
                        Sign in to view interest signups and partner inquiries.
                    </p>
                </div>
                <div className="mt-7 space-y-5">
                    <div>
                        <label htmlFor="admin-email" className="field-label">
                            Email
                        </label>
                        <input
                            id="admin-email"
                            type="email"
                            data-testid="admin-login-email-input"
                            className="input-field"
                            autoComplete="username"
                            {...register("email", {
                                required: "Please enter your email address.",
                                pattern: { value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/, message: "That email address doesn't look right." },
                            })}
                        />
                        {errors.email && (
                            <p className="error-text" role="alert" data-testid="admin-login-email-error">
                                {errors.email.message}
                            </p>
                        )}
                    </div>
                    <div>
                        <label htmlFor="admin-password" className="field-label">
                            Password
                        </label>
                        <input
                            id="admin-password"
                            type="password"
                            data-testid="admin-login-password-input"
                            className="input-field"
                            autoComplete="current-password"
                            {...register("password", { required: "Please enter your password." })}
                        />
                        {errors.password && (
                            <p className="error-text" role="alert" data-testid="admin-login-password-error">
                                {errors.password.message}
                            </p>
                        )}
                    </div>
                    {error && (
                        <p className="error-text" role="alert" data-testid="admin-login-error">
                            {error}
                        </p>
                    )}
                    <button type="submit" disabled={isSubmitting} data-testid="admin-login-submit" className="btn-primary w-full text-lg">
                        {isSubmitting ? "Signing in…" : "Sign in"}
                    </button>
                </div>
                <p className="mt-5 text-base text-ink-soft">Access is limited to the site owner.</p>
            </form>
        </div>
    );
}